import { render, staticRenderFns } from "./ShowResults.vue?vue&type=template&id=46e02c60"
import script from "./ShowResults.vue?vue&type=script&lang=ts"
export * from "./ShowResults.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports